exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Vue-Toastification__toast--success.my-custom-toast-class {\n       background-color: black ;\n}\n", ""]);

// exports
